module.exports = __webpack_public_path__ + "static/media/docker.e3dfe2a5.png";